<template>
    <div>
        <div class="card-body">
            <div class="btn-toolbar justify-content-between mb-2" role="toolbar">
                <div class="form-inline pl-2 col-lg-6 col-md-12">
                    <button type="button" class="btn btn-primary" @click.stop="createBtnClick">
                        {{ $t('buttons.create.btnText_a') }}
                    </button>
                </div>
                <div class="input-group col-lg-6 col-md-12">
                    <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary"
                            @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>

            <kendo-datasource ref="datasource1"
                              :transport="transportSettings"
                              :schema-model-id="'id'"
                              :schema-model-fields="schemaModelFields"
                              :schema-total="'count'"
                              :schema-data="'items'"
                              :page-size='defaultGridRows'
                              :error="dataSourceError"
                              :requestEnd="datasorceRequestEnd">
            </kendo-datasource>

            <kendo-grid ref="grid"
                        :data-source-ref="'datasource1'"
                        :navigatable="gridOptions.navigatable"
                        :editable="false"
                        :filterable="gridOptions.filterable"
                        :pageable="gridOptions.pageable"
                        :reorderable="gridOptions.reorderable"
                        :resizable="gridOptions.resizable"
                        :groupable="false"
                        :allow-copy="gridOptions.allowCopy"
                        :column-menu="gridOptions.columnMenu"
                        :sortable-mode="gridOptions.sortable.mode"
                        :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                        :sortable-show-indexes="gridOptions.sortable.showIndexes"
                        :selectable="gridOptions.selectable"
                        :scrollable="gridOptions.scrollable">
                <kendo-grid-column :field="'id'"
                                   :filterable="false"
                                   :title="$t('finance.tariffEntity.gridHeaders.id')"
                                   :width="100"
                                   :expandable="true">
                </kendo-grid-column>
                <kendo-grid-column field="btnsColumn"
                                   :title="$t('actions')"
                                   :template="btnsTemplate"
                                   :sortable="false"
                                   :filterable="false"
                                   :width="150">
                </kendo-grid-column>
                <!-- <kendo-grid-column :field="'contractModel'"
                                   :title="$t('finance.tariffEntity.gridHeaders.contract')"
                                   :template="contractCellTemplate"
                                   :width="150">
                </kendo-grid-column> -->
                <kendo-grid-column field="contractName"
                                   :title="$t('finance.tariffEntity.gridHeaders.contract')"
                                   :hidden="isEnVersion"
                                   :width="150">
                </kendo-grid-column>
                <kendo-grid-column field="contractNameEn"
                                   :title="$t('finance.tariffEntity.gridHeaders.contract')"
                                   :hidden="!isEnVersion"
                                   :width="150">
                </kendo-grid-column>
                <kendo-grid-column :field="'valid'"
                                   :template="validCellTemplate"
                                   :title="$t('finance.tariffEntity.gridHeaders.valid')"
                                   :width="150">
                </kendo-grid-column>
                <kendo-grid-column :field="'name'"
                                   :title="$t('finance.tariffEntity.gridHeaders.name')"
                                   :width="200">
                </kendo-grid-column>
                <kendo-grid-column :field="'nameEn'"
                                   :title="$t('finance.tariffEntity.gridHeaders.nameEn')"
                                   :width="200">
                </kendo-grid-column>
                <kendo-grid-column :field="'description'"
                                   :title="$t('finance.tariffEntity.gridHeaders.description')"
                                   :width="200">
                </kendo-grid-column>
                <kendo-grid-column :field="'deactivated'"
                                   :title="$t('finance.tariffEntity.gridHeaders.deactivated')"
                                   :hidden="true"
                                   :width="150">
                </kendo-grid-column>
                <kendo-grid-column :field="'deleted'"
                                   :template="deletedCellTemplate"
                                   :title="$t('finance.tariffEntity.gridHeaders.deleted')"
                                   :width="150">
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import tariffService from '../../services/tariff.service'
    import { mapGetters } from 'vuex'

    export default {
        data: function () {
            return {
                searchQuery: '',
                defaultGridRows: this.$store.getters.defaultGridRows,
                schemaModelFields: {
                    id: { field: 'id', type: 'number', nullable: false, editable: false },
                    contractId: { field: 'contractId', type: 'number', nullable: true, editable: false },
                    name: { field: 'name', type: 'string', nullable: false, editable: true, validation: { required: true } },
                    nameEn: { field: 'nameEn', type: 'string', nullable: true, editable: true },
                    contractName: { field: 'contractName', type: 'string', nullable: true, editable: true },
                    contractNameEn: { field: 'contractNameEn', type: 'string', nullable: true, editable: true },
                    description: { field: 'description', type: 'string', nullable: true, editable: true },
                    deactivated: { field: 'deactivated', type: 'boolean', nullable: false, editable: true, visible: false },
                    updated: { field: 'updated', type: 'boolean', nullable: false, editable: false },
                    deleted: { field: 'deleted', type: 'boolean', nullable: false, editable: false },
                    valid: { field: 'valid', type: 'boolean', nullable: false, editable: false },
                    contractModel: {
                        defaultValue: { id: 0, text: 'Избери...', textEx: 'Select...' }
                    },
                    active: { field: 'active', type: 'boolean', nullable: false, editable: false, visible: true },
                    contractViewModel: { field: 'contractViewModel' }
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/tariffs/listTariffEntities',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                }
            }
        },
        methods: {
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    return kendo.stringify(options);
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                })
            },
            datasorceRequestEnd(e) {

            },
            contractCellTemplate: function (dataItem) {
                if (dataItem.contractModel === null) {
                    return kendo.htmlEncode("");
                }

                if (dataItem.contractModel.text === null && dataItem.contractModel.textEn === null) {
                    return kendo.htmlEncode("");
                }

                let templateHtml = '<span>' + kendo.htmlEncode(this.isEnVersion ? dataItem.contractModel.textEn : dataItem.contractModel.text) + '</span>';

                return templateHtml;
            },
            deletedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.deleted ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deleted ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            activeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            validCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.valid ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.valid ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [
                            {
                                name: "edit",
                                text: this.$t('buttons.edit.btnText'),
                                tooltip: this.$t('buttons.edit.btnText'),
                                class: 'btn btn-primary',
                                icon: "fas fa-edit",
                                show: this.hasUpdateRights,
                                clickHandler: this.editBtnClick
                            },
                            {
                                name: "copy",
                                text: this.$t('buttons.copy.btnText'),
                                tooltip: this.$t('buttons.copy.btnText'),
                                class: 'btn btn-primary',
                                icon: "fas fa-copy",
                                show: this.hasCreateRights,
                                clickHandler: this.copyBtnClick
                            },
                            {
                                name: "delete",
                                text: this.$t('buttons.delete.btnText'),
                                tooltip: this.$t('buttons.delete.btnText'),
                                class: 'btn btn-danger',
                                icon: "fas fa-trash-alt",
                                show: this.hasDeleteRights,
                                clickHandler: this.deleteBtnClick
                            }
                        ]
                    }
                };
            },
            createBtnClick() {
                if (!this.hasCreateRights) {
                    return this.$router.push(`/unauthorized`)
                }

                return this.$router.push(`/tariff/create`)
            },
            editBtnClick(args) {
                if (!this.hasUpdateRights) {
                    return this.$router.push(`/unauthorized`)
                }

                return this.$router.push(`/tariff/edit/${args.id}`)
            },
            deleteBtnClick(args) {
                if (!this.hasDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                kendo.confirm(`${this.$t('buttons.delete.confirmationText1', { name: this.isEnVersion ? args.nameEn : args.name })}`)
                    .then(function () {
                        this.deleteTariff(args.id)
                    }.bind(this));
            },
            deleteTariff(id) {
                tariffService.delete(id)
                    .then((response) => {
                        this.refresh()

                        this.$vs.notify({
                            title: this.$t('buttons.delete.action'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    })
            },
            copyBtnClick(args) {
                let routeData = this.$router.resolve({ name: 'copyTariff', params: { id: args.id } });
                window.open(routeData.href, '_blank');
            },
            refresh() {
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
        },
        computed: {
            ...mapGetters(['gridOptions']),
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            hasReadRights() {
                return this.$store.getters.claims.tariff.read;
            },
            hasCreateRights() {
                return this.$store.getters.claims.tariff.create;
            },
            hasUpdateRights() {
                return this.$store.getters.claims.tariff.update;
            },
            hasDeleteRights() {
                return this.$store.getters.claims.tariff.delete;
            },
        }
    }
</script>
